import { Pipe, PipeTransform } from '@angular/core';
import { ExerciceRow } from '../providers/exercices-provider';

import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { ExerciceCategory } from "../../common/models/exercice-category";

@Pipe({standalone: true, name: 'filterExerciceRow'})
export class FilterExerciceRowPipe implements PipeTransform {

    constructor(
        public _utils: UtilsProvider,
    ) {
    }

    public transform(exerciceRows: ExerciceRow[], rawSearch: string, searchCategories: ExerciceCategory[]): ExerciceRow[] {
        // on filtre par recherche s�mantique et s�lection de cat�gorie (accent)
        // si l'un des deux filtres n'est pas renseign�, on l'ignore
        if (!rawSearch) {
            rawSearch = '';
        }
        if (!searchCategories) {
            searchCategories = [];
        }

        let filtered: ExerciceRow[] = exerciceRows.slice();

        if (rawSearch.length) {
            // on recherche individuellement chacun des termes de la recherche s�mantique
            // le caract�re de s�paration et l'espace " "
            // on va chercher dans une chaine normalis�e qui est compos�e de :
            //      - nom de l'exercice
            //      - la description de l'exercice s'il y en a une
            //      - le pr�nom et nom de l'auteur de l'exercice
            //      - les cat�gories de l'exercice (accents)
            //      - les tags de l'exercice
            const searchTerms: string[] = rawSearch.split(' ').map((str: string) => this._utils.normalizeString(str));
            filtered = exerciceRows.filter((row: ExerciceRow) => {
                const workString: string = this._utils.normalizeString(
                    row.exercice.name
                    + (row.exercice.description ? row.exercice.description : '')
                    + row.creater?.firstName + row.creater?.lastName
                    + this._utils.getKeyValues(row.categories, 'name').join('')
                    + (row.exercice.tags ? row.exercice.tags : '')
                );

                for (let i = 0; i < searchTerms.length; i++) {
                    if (!workString.includes(searchTerms[i])) {
                        return false;
                    }
                }

                return true;
            });
        }

        if (searchCategories.length) {
            filtered = filtered.filter((row: ExerciceRow) => {
                for (let i = 0; i < row.categories.length; i++) {
                    if (row.categories[i] && !this._utils.findIn(row.categories[i].id, searchCategories, 'id')) {
                        return false;
                    }
                }

                return true;
            });
        }

        return filtered;

    }
}
